import React from 'react';
import SafeIcon from '../../../common/SafeIcon';

export default function HistoryModal({ isOpen, onClose, logs }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[80vh] flex flex-col">
        <div className="p-4 border-b flex justify-between items-center bg-gray-50 rounded-t-lg">
          <h2 className="text-lg font-bold text-gray-800 flex items-center gap-2">
            <SafeIcon name="Clock" /> Edit History
          </h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            <SafeIcon name="X" />
          </button>
        </div>
        <div className="p-4 overflow-y-auto flex-1 space-y-4">
          {logs.length === 0 ? (
            <div className="text-center text-gray-500 py-8">No history available for this block yet.</div>
          ) : (
            logs.map((log, i) => (
              <div key={i} className="border border-gray-200 rounded-md p-3 bg-gray-50">
                <div className="flex justify-between items-center mb-2">
                  <span className="font-bold text-sm text-gray-700">{log.changed_by}</span>
                  <span className="text-xs text-gray-500">{new Date(log.changed_at).toLocaleString()}</span>
                </div>
                <div className="text-sm">
                  <span className="font-medium text-gray-600">{log.field_name}:</span>{' '}
                  <span className="line-through text-red-400">{log.old_value || '(empty)'}</span>{' '}
                  <SafeIcon name="ArrowRight" className="inline text-gray-400 text-xs mx-1" />{' '}
                  <span className="text-green-600">{log.new_value || '(empty)'}</span>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}